import type { RootState } from 'store/index';

import type { Roles } from 'constants/enums';
import type { JwtToken, User } from 'models/user.interface';

export const jwtTokenSelector = (state: RootState): JwtToken|null => state.loggedUser.jwtToken;
export const loggedUserSelector = (state: RootState): User|null => state.loggedUser.user;
export const userRoleSelector = (state: RootState): Roles|null => state.loggedUser.role;
export const userClientIdSelector = (state: RootState): string => state.loggedUser.clientId;
